export default [{
	path: 'main',
	name: 'Main',
	component: resolve => require(['@/views/Main/index.vue'], resolve),
	meta: {
		title: '首页',
		name: 'main',
	}
}];



// WEBPACK FOOTER //
// ./src/router/modules/main.route.js